import type {ScreenText} from '../types/textTypes'

// Force-load every web font used by the given 2D texts, then wait for in-flight font
// loads to settle. Canvas `fillText` does NOT trigger font loading on its own, so on a
// freshly-loaded page (notably the render micro-frontend) the text renderer would draw
// in the fallback font. The editor only avoids this because its live DOM TextOverlay
// span warms the font during editing. Safe no-op when `document.fonts` is unavailable.
export const ensureTextFonts = async (texts: ScreenText[]): Promise<void> => {
  if (typeof document === 'undefined' || !document.fonts) return

  // Dedupe by face — size is irrelevant to which @font-face loads.
  const specs = new Set<string>()
  for (const t of texts) {
    const style = t.italic ? 'italic' : 'normal'
    const weight = t.bold ? '700' : '400'
    specs.add(`${style} ${weight} 16px "${t.fontFamily}"`)
  }

  await Promise.all(
    [...specs].map((spec) =>
      // A missing/blocked font must not abort the render — it just falls back.
      document.fonts.load(spec).catch(() => undefined),
    ),
  )
  await document.fonts.ready
}
